export default __webpack_public_path__ + "static/media/breakpanel_icone.dbf396f4.svg";